import companySaga from './sagas/CompanySaga';

export default [
    companySaga,
];